// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../Config.bs.js";
import * as $$String from "../../../../../node_modules/rescript/lib/es6/string.js";
import * as Json_encode from "../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as NetworkUtils from "../../../../library/utils/NetworkUtils.bs.js";
import * as RnrRepoConfig from "./RnrRepoConfig.bs.js";
import * as Logger$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as Network$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";

function fetchRnrReport(uuid, authToken, lang) {
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getRnrHostName(undefined),
        tl: {
          hd: "/api/v1/rnr/drivers/",
          tl: {
            hd: uuid,
            tl: {
              hd: "/rnr_report/",
              tl: {
                hd: lang,
                tl: /* [] */0
              }
            }
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.getRequestV3(requestUrl, authToken, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(RnrRepoConfig.RnrReportResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function claimRnrReward(uuid, authToken, lang, reward_ids) {
  var payloadString = JSON.stringify(Json_encode.object_({
            hd: [
              "reward_ids",
              $$Array.map((function (id) {
                      return id;
                    }), reward_ids)
            ],
            tl: {
              hd: [
                "status",
                "CLAIMED"
              ],
              tl: /* [] */0
            }
          }));
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getRnrHostName(undefined),
        tl: {
          hd: "/api/v1/rnr/drivers/",
          tl: {
            hd: uuid,
            tl: {
              hd: "/rewards?lang=",
              tl: {
                hd: lang,
                tl: /* [] */0
              }
            }
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.putRequest(requestUrl, payloadString, authToken, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(RnrRepoConfig.RnrClaimResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchRnrBanners(uuid, authToken) {
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getRnrHostName(undefined),
        tl: {
          hd: "/api/v1/rnr/driver/",
          tl: {
            hd: uuid,
            tl: {
              hd: "/rnr_banners",
              tl: /* [] */0
            }
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.getRequestV3(requestUrl, authToken, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(RnrRepoConfig.RnrBannersResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var RnrRepo = {
  fetchRnrReport: fetchRnrReport,
  claimRnrReward: claimRnrReward,
  fetchRnrBanners: fetchRnrBanners
};

export {
  RnrRepo ,
  
}
/* Config Not a pure module */
